import {handleResponse} from "@/services/service-helpers.ts"
import {BankDataValidationEntry, BankDataValidationType} from "@/models/bank-data-validation.ts"
import log from '@/lib/logger'

const NBH_BANK_DATA_VALIDATION_BASE_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/reports/bank-data-validation`

export async function getBankDataValidation(
    token: string | null,
    type: BankDataValidationType = "INVALID_DATA",
): Promise<BankDataValidationEntry[]> {
    if (!token) {
        log.error("No token provided to request bank data validation")
        return Promise.reject("No token provided")
    }

    const response = await fetch(`${NBH_BANK_DATA_VALIDATION_BASE_URL}?type=${type}`, {
        method: 'GET',
        headers: new Headers({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        })
    })

    const result = await handleResponse<BankDataValidationEntry[]>(response)
    return result || []
}
